import { ExternalLink } from "lucide-react";
import { DownloadLink } from "@/components/brand/BrandSection";

export const FontCard = ({ font }) => {
  const slug = font.name.toLowerCase().replace(/\s+/g, "-");
  return (
    <article className="rounded-[28px] border border-sky-100 bg-white p-6" data-testid={`brand-font-${slug}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="font-display text-xl font-semibold text-ink">{font.name}</h3>
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">{font.weights}</p>
      </div>
      <p className="mt-1 text-sm text-slate-600">{font.role}</p>
      <p className="mt-5 break-words text-3xl leading-tight text-ink sm:text-4xl"
        style={{ fontFamily: font.css, fontWeight: font.weight, fontStyle: font.italic ? "italic" : "normal", textTransform: font.upper ? "uppercase" : "none", letterSpacing: font.upper ? "0.12em" : font.weight === 600 ? "-0.02em" : 0, fontSize: font.upper ? "1.25rem" : undefined }}>
        {font.sample}
      </p>
      <p className="mt-3 break-words text-sm text-slate-600" style={{ fontFamily: font.css, fontStyle: font.italic ? "italic" : "normal" }}>
        ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789
      </p>
      <div className="mt-5 flex flex-wrap gap-2">
        {font.files.filter((f) => f.endsWith(".ttf")).map((f) => <DownloadLink key={f} href={`/brand/fonts/${f}`} label={f} testid={`brand-font-file-${f}`} />)}
        <a href={`https://fonts.google.com/specimen/${font.gf}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-sky-700 hover:bg-sky-50" data-testid={`brand-font-${slug}-google`}>
          Google Fonts<ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
    </article>
  );
};
